import { render, staticRenderFns } from "./ValidPhone.vue?vue&type=template&id=7ec2c2cf&scoped=true&"
import script from "./ValidPhone.vue?vue&type=script&lang=ts&"
export * from "./ValidPhone.vue?vue&type=script&lang=ts&"
import style0 from "./ValidPhone.vue?vue&type=style&index=0&id=7ec2c2cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2c2cf",
  null
  
)

export default component.exports